module.exports = __webpack_public_path__ + "static/media/SlatePro-Italic.3f85abf8.otf";